var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Box } from '@mui/material';
import React from 'react';
import { gradients } from '../ColorPaper';
import { themeColors } from '../JuvareTheme';
/**
 * Slideout header component used to display brief information related to the slideout content.
 * Can have a gradient background.
 */
export const ModalSlideoutHeader = (_a) => {
    var { gradient, sx, children } = _a, props = __rest(_a, ["gradient", "sx", "children"]);
    return (React.createElement(Box, { sx: [
            {
                borderRadius: 0,
                pt: 8,
                px: 2,
                pb: gradient ? { xs: 4, sm: 5 } : null,
                display: 'flex',
                flexDirection: 'column',
                gap: 3,
            },
            gradient ? Object.assign(Object.assign({}, gradients[gradient]), { color: themeColors.decorative.white }) : null,
            ...(Array.isArray(sx) ? sx : [sx]),
        ], "data-test": props['data-test'] }, children));
};
